module.exports = __webpack_public_path__ + "static/media/mammo-qc.a430136d.svg";